import { render } from "./MyNumber.vue?vue&type=template&id=acc72850&scoped=true"
import script from "./MyNumber.vue?vue&type=script&lang=js"
export * from "./MyNumber.vue?vue&type=script&lang=js"

import "./MyNumber.vue?vue&type=style&index=0&id=acc72850&lang=scss&scoped=true"

import exportComponent from "D:\\lpl\\szy\\cloud-api-web-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acc72850"]])

export default __exports__